export function parentIndex(i) {
  if (i <= 0) return null;
  return Math.floor((i - 1) / 4);
}

export function childIndex(i, slot) {
  if (slot < 0 || slot > 3) {
    throw new Error(`childIndex slot out of range: ${slot}`);
  }
  return 4 * i + 1 + slot;
}

export function createHeapTopologyState(rootNodeId) {
  if (!rootNodeId) {
    throw new Error('createHeapTopologyState requires rootNodeId');
  }
  return {
    nextInsertIndex: 1,
    heapIndexToNodeId: {
      0: rootNodeId,
    },
    nodeIdToHeapIndex: {
      [rootNodeId]: 0,
    },
  };
}

export function appendNodeToHeap(topologyState, nodeId) {
  if (!topologyState || !nodeId) {
    throw new Error('appendNodeToHeap requires topologyState and nodeId');
  }

  const heapIndex = topologyState.nextInsertIndex;
  const parentHeapIndex = parentIndex(heapIndex);

  topologyState.heapIndexToNodeId[heapIndex] = nodeId;
  topologyState.nodeIdToHeapIndex[nodeId] = heapIndex;
  topologyState.nextInsertIndex += 1;

  return {
    heapIndex,
    parentHeapIndex,
  };
}
